import { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

export const isNative = Capacitor.isNativePlatform();

/**
 * Abre uma URL externa de forma adequada para cada plataforma:
 * - Nativo (Capacitor): in-app browser (Safari View Controller / Chrome Custom Tab)
 * - Web: redirect normal na mesma aba
 */
export async function openExternalUrl(url: string): Promise<void> {
  if (isNative) {
    await Browser.open({ url });
  } else {
    window.location.href = url;
  }
}

export function useIsMobileViewport(breakpoint = 640) {
  const [mobile, setMobile] = useState(() =>
    typeof window === 'undefined' ? false : window.innerWidth < breakpoint,
  );
  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const onChange = () => setMobile(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [breakpoint]);
  return mobile;
}

export function useShowBottomNav() {
  const mobile = useIsMobileViewport();
  return isNative || mobile;
}
